import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  showen = false;
  showfr = false;
  showru = false;
  showpr = false;
  showar = false;
  showch = false;
  showde = false;
  showsp = false;
  showandroid = false;
  showios = false;
  showboth = false;
  deviceInfo = null;
  isMobile = false;
  isTablet = false;
  isDesktopDevice = false;
  constructor(private deviceService: DeviceDetectorService) {
    this.epicFunction();
  }
  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }
  ngOnInit(){
    this.getallsuccess()
    this.getMobileOperatingSystem()
  }
  getallsuccess() {
    const language = localStorage.getItem('language');
    if(language){
      this.showdivbylanguage(language)
    }else{
      localStorage.setItem("language", "en");
      this.showen = true;
    }
  }
  hidealldiv(){
    this.showen = false;
    this.showfr = false;
    this.showru = false;
    this.showar = false;
    this.showpr = false;
    this.showch = false;
    this.showde = false;
    this.showsp = false
  }
  showdivbylanguage(val){
    this.hidealldiv()
    localStorage.setItem("language", val);
    switch(val) {
      case 'en':
        this.showen = true;
        break;
      case 'fr':
        this.showfr = true;
        break;
      case 'tu':
        this.showru = true;
        break;
      case 'pr':
        this.showpr = true;
        break;
      case 'ar':
        this.showar = true;
        break;
      case 'ch':
          this.showch = true;
          break;
      case 'sp':
          this.showsp = true;
          break;
      case 'de':
          this.showde = true;
          break;
      default:
        this.showen = true;
    }
  }
  /**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
  getMobileOperatingSystem() {
    this.showandroid = false;
    this.showios = false;
    this.showboth = false;
    if(this.isMobile){
      if(this.deviceInfo?.os == "Android"){
        this.showandroid = true;
      } else if(this.deviceInfo?.os == "iOS"){
        this.showios = true;
      }
    }else if(this.isTablet){
      if(this.deviceInfo?.os == "Android"){
        this.showandroid = true;
      } else if(this.deviceInfo?.os == "Mac"){
        this.showios = true;
      } else if(this.deviceInfo?.os == "Linux"){
        this.showboth = true;
      }
    }else if(this.isDesktopDevice){
      this.showboth = true;
    }

    /*if(!this.showboth){
      if(this.showandroid){
        location.href = 'https://play.google.com/store/apps/details?id=com.totalenergies.lubscan';
      }else if(this.showios){
        location.href = 'https://apps.apple.com/app/lubscan-by-totalenergies/id6532624090';
      }
    }*/
}
}
